import { useCallback } from 'react';

import { useAnalytics } from '../../analytics/hook';
import { getPageInfoFromRouteConfig } from '../../analytics/utils';

import { GetTrackingTagsFn, ShareFilterModalTags } from './types';

interface ShareFilterModalElementClickedAnalytics {
  getTrackingTags: GetTrackingTagsFn;
  shareItemName: string;
  filterName: string;
  shareWithTotal: number;
  shareAdded: number;
  shareRemoved: number;
}

interface UseFilterAnalyticsReturnType {
  trackShareFilterModalElementClicked: (eventProps: ShareFilterModalElementClickedAnalytics) => void;
}

export const useFilterAnalytics = (): UseFilterAnalyticsReturnType => {
  const { track } = useAnalytics();

  const trackShareFilterModalElementClicked = useCallback(
    (eventProps: ShareFilterModalElementClickedAnalytics) => {
      const {
        section: sectionFromConfig,
        pageName: pageNameFromConfig,
        subsection: subsectionFromConfig,
      } = getPageInfoFromRouteConfig(window.location.pathname);
      const { access, pageName, section, subsection } = eventProps.getTrackingTags?.() ?? {
        access: '',
        pageName: '',
        section: '',
        subsection: '',
      };

      track<ShareFilterModalTags>('Page Element Clicked', {
        access: access ?? '',
        pageName: pageName ?? pageNameFromConfig,
        section: section ?? sectionFromConfig,
        subsection: subsection ?? subsectionFromConfig,
        filterName: eventProps.filterName,
        elementType: 'Filter',
        elementCategory: 'Button',
        shareItemName: eventProps.filterName,
        shareWithTotal: eventProps.shareWithTotal,
        shareAdded: eventProps.shareAdded,
        shareRemoved: eventProps.shareRemoved,
      });
    },
    [track]
  );

  return {
    trackShareFilterModalElementClicked,
  };
};
